import { ReactElement, ReactNode } from 'react';
import { Error } from '@/components/Error';
import { ErrorBoundary } from '@/components/ErrorBoundary';
import { PageLayout } from './PageLayout';

export function DefaultPageLayout({
  children,
}: {
  children: ReactNode;
}): ReactElement {
  return (
    <PageLayout>
      <ErrorBoundary fallback={<Error />}>{children}</ErrorBoundary>
    </PageLayout>
  );
}
